/* eslint-disable @typescript-eslint/no-unused-vars */
import i18nInst from 'src/i18n';
import {
  ActionEnum,
  DlpExchangePolicyItem,
  DlpPolicyFilters,
  DlpPolicyItem,
  KeywordExtractionFilter,
  KfContainRule,
  Notification,
} from '@Policy/utils/types';
import isEqual from 'lodash/isEqual';
import { FilterValidator, checkNotification } from '@Policy/utils/fns';

export const createKeywordExtractionFilterSlice = (
  setPolicy: any,
  getPolicy: any,
  getAll: any
) => {
  const { t } = i18nInst;
  return {
    setKfState: (payload: Partial<KeywordExtractionFilter>) => {
      setPolicy((state: DlpExchangePolicyItem) => ({
        ...state,
        tmKeywordfilters: {
          ...state.tmKeywordfilters,
          ...payload,
        },
      }));
    },
    setKfNtfState: (payload: Partial<Notification>) => {
      setPolicy((state: DlpExchangePolicyItem) => ({
        ...state,
        tmKeywordfilters: {
          ...state.tmKeywordfilters,
          notification: {
            ...(state.tmKeywordfilters?.notification || {}),
            ...payload,
          },
        },
      }));
    },
    addKfContainRule: (rules: KfContainRule[]) => {
      // do not add if duplicate
      const policy = getPolicy();
      const { kfContainRules = [] } = policy.tmKeywordfilters || {};
      const addRules: KfContainRule[] = [];
      rules.forEach((rule: KfContainRule) => {
        if (
          !kfContainRules.find((item: KfContainRule) => {
            return (
              item.kfFileType === rule.kfFileType &&
              item.kfContainType === rule.kfContainType &&
              isEqual(item.tmKeywords, rule.tmKeywords)
            );
          })
        ) {
          addRules.push(rule);
        }
      });
      // add to the store
      setPolicy((state: DlpPolicyItem) => {
        state.tmKeywordfilters?.kfContainRules.push(...addRules);
      });
    },
    deleteKfContainRule: (index: number) => {
      const policy = getPolicy();
      const { kfContainRules = [] } = policy.tmKeywordfilters || {};
      if (index < 0 || index >= kfContainRules.length) {
        return;
      }
      setPolicy((state: DlpPolicyItem) => {
        state.tmKeywordfilters?.kfContainRules.splice(index, 1);
      });
    },
    setKfContainRuleAction: (index: number, action: ActionEnum) => {
      const policy = getPolicy();
      const { kfContainRules = [] } = policy.tmKeywordfilters || {};
      if (index < 0 || index >= kfContainRules.length) {
        return;
      }
      const isValid = [
        ActionEnum.quarantine,
        ActionEnum.delete,
        ActionEnum.pass,
      ].includes(Number(action));
      if (isValid) {
        setPolicy((state: DlpPolicyItem) => {
          const rule = state.tmKeywordfilters?.kfContainRules[index];
          if (rule) {
            rule.kfNonCollaborationActionType = action.toString();
          }
        });
      }
    },
    validateKeywordExtraction: () => {
      const currentState = getPolicy();
      const filter = currentState.tmKeywordfilters;
      const validator = new FilterValidator(DlpPolicyFilters.tmKeywordfilters);
      validator.add(filter.notification, 'checkNotification');
      validator.add(
        { keyValue: filter.kfReplacementText, keyName: 'kfReplacementText' },
        'checkToken'
      );
      validator.add(
        { keyValue: filter.kfReplacementText, keyName: 'kfReplacementText' },
        'checkReplacementText'
      );
      // check contain rules
      const result = validator.check();
      return result;
    },
  };
};
